$( document ).ready(function( $ ) {
  var screenWidth = window.innerWidth;
  $('#mvslider').sliderPro({
    width: '100%',
    autoHeight: true,
    arrows: false,
    buttons: false,
    slideDistance:0,
  });
  if (screenWidth < 690) {
    $('#ftslider').sliderPro({
      width: '100%',
      height: 620,
      arrows: false,
      buttons: false,
      slideDistance: 0,
      loop: false,
      autoplay: false
    });
  } else {
    $('#eventhouse').on('click', function(e){
      e.target.src = 'images/pc_house/onmouse.png';
      $('#eventhousePc').attr('srcset','images/pc_house/onmouse.png');
    });
  }
});
